import { useEffect } from 'react';

const SEOHead = ({ 
  title = "Saner Consulting - Business Transformation & AI Implementation Experts",
  description = "Expert business transformation consultancy specializing in AI implementation, digital transformation, and portfolio management. 25+ years experience supporting £500m+ annual investments across 5+ countries.",
  keywords = "business transformation, AI implementation, digital transformation, change management, portfolio management, transformation assurance, consulting, UK, London",
  canonical = "https://sanerconsulting.co.uk/",
  ogImage = "/images/hero/business-meeting-hero.jpg"
}) => {
  useEffect(() => {
    // Update document title
    document.title = title;
    
    // Update meta description
    const metaDescription = document.querySelector('meta[name="description"]');
    if (metaDescription) {
      metaDescription.setAttribute('content', description);
    }
    
    // Update meta keywords
    let metaKeywords = document.querySelector('meta[name="keywords"]');
    if (metaKeywords) {
      metaKeywords.setAttribute('content', keywords);
    }
    
    // Update Open Graph title
    const ogTitle = document.querySelector('meta[property="og:title"]');
    if (ogTitle) {
      ogTitle.setAttribute('content', title);
    }
    
    // Update Open Graph description
    const ogDescription = document.querySelector('meta[property="og:description"]');
    if (ogDescription) {
      ogDescription.setAttribute('content', description);
    }
    
    // Update Open Graph URL
    const ogUrl = document.querySelector('meta[property="og:url"]');
    if (ogUrl) {
      ogUrl.setAttribute('content', canonical);
    }
    
    // Update Open Graph image
    const ogImageMeta = document.querySelector('meta[property="og:image"]');
    if (ogImageMeta) {
      ogImageMeta.setAttribute('content', `https://sanerconsulting.co.uk${ogImage}`);
    }
    
    // Update Twitter title
    const twitterTitle = document.querySelector('meta[property="twitter:title"]');
    if (twitterTitle) {
      twitterTitle.setAttribute('content', title);
    }
    
    // Update Twitter description
    const twitterDescription = document.querySelector('meta[property="twitter:description"]');
    if (twitterDescription) {
      twitterDescription.setAttribute('content', description);
    }
    
    // Update Twitter image
    const twitterImage = document.querySelector('meta[property="twitter:image"]');
    if (twitterImage) {
      twitterImage.setAttribute('content', `https://sanerconsulting.co.uk${ogImage}`);
    }
    
    // Update canonical URL
    let canonical_link = document.querySelector('link[rel="canonical"]');
    if (canonical_link) {
      canonical_link.setAttribute('href', canonical);
    }
    
  }, [title, description, keywords, canonical, ogImage]);

  return null; // This component doesn't render anything
};

export default SEOHead;